<template lang="pug">
v-flex(style="height: inherit;")
  v-layout(row style="justify-content: center; gap: 80px; height: inherit;")
    .main-vida-free
      v-layout.box-vida-free-body(column style="width: 23.5em;")
        v-flex.first-section
          v-layout(column)
            v-flex.title
              p Hola {{ usuario.titleName }},
              p Estos son los datos de tu seguro&nbsp;
                span Vida Free
            v-flex.options-buttons
              v-layout(row)
                v-flex
                  ButtonSelect(
                    :textBottunProp="'Plan'"
                    :main="true"
                    :activar="flagPlan"
                    @selectButton="methodView"
                  )
                v-flex
                  ButtonSelect(
                    :textBottunProp="'Hoy'"
                    :activar="flagHoy"
                    @selectButton="methodView"
                  )
            v-flex.box-detail
              v-layout(column align-center)
                v-flex
                  span.omnesMedium(style="font-size:16px;") Monto protección principal
                v-flex.detail
                  IconText(
                    :iconMoney="iconMoneyMontoAsegurado"
                    :typeMoney="poliza.tipoMoneda"
                    :textMoney="poliza.montoAsegurado"
                  )
                v-flex.detail
                  v-layout(row)
                    v-flex
                      CardNumberText(
                        :textNumber="poliza.periodoDePago + ' '+ (poliza.periodoDePago > 1 ? 'años' : 'año')"
                        :description="'Periodo de pago'"
                      )
                    v-flex
                      CardNumberText(
                        :textNumber="poliza.montoCuota"
                        :description="'Cuota '+ poliza.frecuenciaPago"
                      )
                    v-flex(@click="methodView('ver coberturas')")
                      CardNumberText(
                        style="cursor: pointer;"
                        :textNumber="poliza.coberturasVida ? poliza.coberturasVida.length : 0"
                        :description="'Ver Coberturas'"
                        :cardBackgroundColor="'#EA0D90'"
                        :hoverButton="'true'"
                      )
            v-flex.box-detail-devolucion(@click="openDevolucionPopup=true")
              CardIconTextDoubleRow(
                :icon="iconDevolucion"
                :text="poliza.tipoMoneda+new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(poliza.montoDevolucion)"
                :detail="Number(poliza.porcentajeDevolucion)*100"
                :ocultarMonto="flagOcultarMontoDevolucion"
              )
        v-flex.second-section
          v-flex.menu-vida-free(@click="methodView('mis seguros')" :style=" flagDatosMisSeguros ? 'border: 1px solid #0855C4 !important' : '' ")
            IconTextIcon(:textProp="'Datos de mi seguro'" :iconTextProp="iconMisDatos" :iconFlagProp="iconlistFlag")
          v-flex.menu-vida-free(@click="methodView('mis solicitudes')" :style=" flagMisSolicitudes ? 'border: 1px solid #0855C4 !important' : '' ")
            IconTextIcon(:textProp="'Mis solicitudes'" :iconTextProp="iconMisSolicitudes" :iconFlagProp="iconlistFlag")
          v-flex.menu-vida-free(@click="methodView('estado de cuenta')" :style=" flagEstadoCuenta ? 'border: 1px solid #0855C4 !important' : '' ")
            IconTextIcon(:textProp="'Mi estado de cuenta'" :iconTextProp="iconMiEstadoCuenta" :iconFlagProp="iconlistFlag")
          v-flex.menu-vida-free(v-if="documentosEndosoDisponibles.length > 0" @click="methodView('documentos de endoso')" :style=" flagDocumentosEndoso ? 'border: 1px solid #0855C4 !important' : '' ")
            IconTextIcon(:textProp="'Documentos de endoso'" :iconTextProp="iconComprobanteElectronico" :iconFlagProp="iconlistFlag")
          v-flex.menu-vida-free(@click="methodView('comprobante')" :style=" flagComprobante ? 'border: 1px solid #0855C4 !important' : '' ")
            IconTextIcon(:textProp="'Comprobante electrónico'" :iconTextProp="iconComprobanteElectronico" :iconFlagProp="iconlistFlag")
          v-flex.menu-vida-free(@click="methodView('beneficiarios')" :style=" flagBeneficiarios ? 'border: 1px solid #0855C4 !important' : '' ")
            IconTextIcon(:textProp="'Mis beneficiarios'" :iconTextProp="iconMisBeneficiarios" :iconFlagProp="iconlistFlag")
          v-flex.menu-vida-free(@click="methodView('mi agente')" :style=" flagMiAgente ? 'border: 1px solid #0855C4 !important' : '' ")
            IconTextIcon(:textProp="'Mi asesor'" :iconTextProp="iconMiAgente" :iconFlagProp="iconlistFlag")
          v-flex.menu-vida-free(@click="methodView('beneficios')" v-if="!mayor5Anhos" :style=" flagBeneficiosDesbloqueados ? 'border: 1px solid #0855C4 !important' : '' ")
            IconTextIcon(:textProp="'Beneficios desbloqueados'" :iconTextProp="iconBeneficios" :iconTextPropHover="''" :iconFlagProp="iconlistFlag")
    .main-vida-free
      v-layout(column align-center style="margin-left: 0em; margin-right: auto; max-width: 35em; min-width: 26em; width: 26.5em;")
        v-flex(style="border: 1px solid #D9D9D9; border-radius: 10px; width:inherit; padding: 1em .7em")
          DatosMisSegurosDesktop(
            v-if="flagDatosMisSeguros"
            @datosMisSegurosMethod="getPDFElectronicPolicy"
            :numeroPoliza="poliza.numeroPoliza"
            :inicioFinVigencia="poliza.fechaVigencia + ' - '+ poliza.fechaFinVigencia"
            :periodoDePago="poliza.periodoDePago + ' '+ (poliza.periodoDePago == 1 ? 'año' : 'años')"
            :periodoDeCobertura="poliza.periodoDeCobertura + ' '+ (poliza.periodoDeCobertura == 1 ? 'año' : 'años')"
            :montoAsegurado="setFormatNumber(poliza.montoDevolucion) || '0'"
            :cuota="(poliza.primaProgramadaMoneda=='NUEVO SOL' ? 'S/' : '$')+''+poliza.montoCuota"
            :frecuenciaDePago="poliza.frecuenciaPago"
            :pagoHasta="poliza.pagadoHasta"
            :tipoMoneda="poliza.tipoMoneda"
            :taggeo="taggeo"
            :producto="poliza.nombreProducto"
            :plan="poliza.plan"
            :hasDocument="!!poliza.codigoProceso && (poliza.codigoProceso || []).length > 0"
          )
          MisSolicitudes(
            v-if="flagMisSolicitudes"
            :mas2Anhos="mas2Anhos"
            :puedeEndosar="poliza.puedeEndosar"
            :puedeCuotaComodin="poliza.puedeCuotaComodin"
            :puedeCambiarFrecuencia="poliza.puedeCambiarFrecuencia"
            :puedeLiberarEndoso="poliza.puedeLiberarEndoso"
            :puedeCambiarBeneficiario="poliza.puedeCambiarBeneficiario"
            :puedeRetirarCoberturas="poliza.puedeRetirarCoberturas"
            :poliza="poliza"
            :taggeo="taggeo"
            :solicitudBeneficiarios="solicitudBeneficiarios"
            :solicitudComodin="solicitudComodin"
            :solicitudEndosoEntidadFinanciera="solicitudEndosoEntidadFinanciera"
            :solicitudLiberacionEndoso="solicitudLiberacionEndoso"
            :solicitudAnulacion="solicitudAnulacion"
            :solicitudSeguimiento="solicitudSeguimiento"
            :action="noActionSend ? null : action"
          )
          EstadoDeCuentaDesktop(
            v-if="flagEstadoCuenta"
            :ceProp="ce"
            :poliza="poliza"
            :taggeo="taggeo"
          )
          ComprobanteElectronicoDesktop(
            v-if="flagComprobante"
            :listaDeComprobantes="listComprobantesElectronicos"
            :iconDescarga="iconDescargaComprobante"
            :poliza="poliza"
            :taggeo="taggeo"
            )
          DocumentosEndoso(
            v-if="flagDocumentosEndoso"
            :taggeo="taggeo"
            :documentos="documentosEndosoDisponibles"
            :id="requerimientoId"
          )
          MisBeneficiariosDesktop(
            style="margin:2rem"
            v-if="flagBeneficiarios"
            :beneficiariosPrincipales = "beneficiariosPrincipalesProp"
            :puedeCambiarBeneficiario="poliza.puedeCambiarBeneficiario"
            :beneficiariosContingentes = "beneficiariosContingentesProp"
            :poliza="poliza"
            :taggeo="taggeo"
            )
          MiAgenteDesktop(
            style="margin-left:2rem;margin-right:2rem"
            v-if="flagMiAgente"
            :nombre="poliza.nombreAgente"
            :correo="poliza.emailAgente"
            :celular="''"
            :taggeo="taggeo"
          )
          BeneficiosDesbloqueados(
            v-if="flagBeneficiosDesbloqueados"
            :mas2Anhos="mas2Anhos"
            :poliza="poliza"
            :solicitudBeneficiarios="solicitudBeneficiarios"
            :solicitudComodin="solicitudComodin"
            :solicitudEndosoEntidadFinanciera="solicitudEndosoEntidadFinanciera"
            :solicitudLiberacionEndoso="solicitudLiberacionEndoso"
            :solicitudAnulacion="solicitudAnulacion"
            :solicitudSeguimiento="solicitudSeguimiento"
            :puedeEndosar="poliza.puedeEndosar"
            :puedeCuotaComodin="poliza.puedeCuotaComodin"
            :puedeCambiarFrecuencia="poliza.puedeCambiarFrecuencia"
            :puedeLiberarEndoso="poliza.puedeLiberarEndoso"
            :puedeCambiarBeneficiario="poliza.puedeCambiarBeneficiario"
            :taggeo="taggeo"
          )
          CoberturasDesktop(
            v-if="flagCoberturas"
            :coberturas="poliza.coberturasVida"
            :tipoMoneda="poliza.tipoMoneda"
            :textTitle1="'Cobertura Principal'"
            :textTitle2="'Coberturas Adicionales'"
            :taggeo="taggeo"
          )
          ProyeccionDesktop(
            v-if="flagProyeccion"
            @closeAlertGoTo = "methodView('plan')"
            :montoAsegurado = "setFormatNumber(poliza.montoDevolucion)"
            :periodos="poliza.tablaDevoluciones.filter(x => x.anho !== '01')"
            :tipoMoneda="poliza.tipoMoneda"
            :numeroPoliza="poliza.numeroPoliza"
            :producto="poliza.nombreProducto"
            :taggeo="taggeo"
          )
          HoyDesktopHasta5(
            style="max-height: 35.6em;overflow-y: auto;padding: 0 .5em;"
            v-if="flagHoyView2"
            :periodos="hoy"
            :periodoDePago="poliza.periodoDePago"
            :tipoMoneda="poliza.tipoMoneda"
            :inicioVigencia="poliza.fechaVigencia"
            :finVigencia="poliza.fechaFinVigencia"
            :pagoHasta="poliza.pagadoHasta"
            :montoAsegurado="(poliza.montoDevolucion || '0')"
            :cuota="poliza.montoCuota"
            :netoAnual="calculoPagoAnual"
            :totalPagoEfectuado="totalPagosEfectuados"
            :cuotaPeriodo="cuotaPeriodo"
            :producto="poliza.oriProducto || ''"
            :taggeo="taggeo"
            :nombreProducto="poliza.nombreProducto"
            :suenio="(poliza.informacionExtra || {}).suenio"
          )
  PopupAlertMessage(
    @closeAlertPopup="closeAlertMethod"
    :openPopup="popupAlert.openPopup"
    :image="popupAlert.image"
    :title="popupAlert.title"
    :message="popupAlert.message"
    :messageButton="popupAlert.messageButton"
    :buttonClose="popupAlert.buttonClose"
    :imgHeight="popupAlert.imgHeight"
    :imgWidth="popupAlert.imgWidth"
  )
  //- LOADER PROCESS
  v-dialog(v-model="loader.flag" persistent width="300")
    v-card(color="primary" dark="")
      v-card-text
        | {{loader.text}}
        v-progress-linear.mb-0(indeterminate="" color="white")

</template>
<script>
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'
import ButtonSelect from '../../components/generic/ButtonSelect.vue'
import CardIconTextDoubleRow from '../../components/generic/CardIconTextDoubleRow.vue'
import CardNumberText from '../../components/generic/CardNumberText.vue'
import IconText from '../../components/generic/IconText.vue'
import IconTextIcon from '../../components/generic/IconTextIcon.vue'
import DatosMisSegurosDesktop from '../../components/mis-seguros/DatosMisSegurosDesktop.vue'
import EstadoDeCuenta from '../../components/mis-seguros/EstadoDeCuenta.vue'
import MiAgenteMobile from '../../components/mis-seguros/MiAgenteMobile.vue'
import PopupCoberturas from '../../components/mis-seguros/PopupCoberturas.vue'
import PopupComprobanteElectronico from '../../components/mis-seguros/PopupComprobanteElectronico.vue'
import PopupMisBeneficiarios from '../../components/mis-seguros/PopupMisBeneficiarios.vue'
import PopupMisSolicitudes from '../../components/mis-seguros/PopupMisSolicitudes.vue'
import PopupAlertMessage from '../../components/PopupAlertMessage.vue'
import electronicVouchers from '../../interfaces/electronicVouchers'
import BeneficiosDesbloqueados from '../../components/mis-seguros/BeneficiosDesbloqueados.vue'
import PopupProyeccion from '../../components/mis-seguros/PopupProyeccion.vue'
import HoyDesktopHasta5 from '../../components/mis-seguros/HoyDesktopHasta5.vue'
import paymentFrequency from '../../interfaces/paymentFrequency'
import MisSolicitudes from '../../components/mis-seguros/MisSolicitudes.vue'
import DocumentosEndoso from '../../components/mis-seguros/DocumentosEndoso.vue'
import EstadoDeCuentaDesktop from '../../components/mis-seguros/EstadoDeCuentaDesktop.vue'
import ComprobanteElectronicoDesktop from '../../components/mis-seguros/ComprobanteElectronicoDesktop.vue'
import MisBeneficiariosDesktop from '../../components/mis-seguros/MisBeneficiariosDesktop.vue'
import MiAgenteDesktop from '../../components/mis-seguros/MiAgenteDesktop.vue'
import CoberturasDesktop from '../../components/mis-seguros/CoberturasDesktop.vue'
import ProyeccionDesktop from '../../components/mis-seguros/ProyeccionDesktop.vue'
import Functionalities from '../../interfaces/functionalities'
import Transacts from '../../interfaces/transacts'

export default {
  props: [
    'infoPoliza',
    'infoUser',
    'action'
  ],
  components: {
    ButtonSelect,
    IconText,
    CardNumberText,
    CardIconTextDoubleRow,
    IconTextIcon,
    PopupAlertMessage,
    PopupCoberturas,
    DatosMisSegurosDesktop,
    PopupMisSolicitudes,
    PopupMisBeneficiarios,
    MiAgenteMobile,
    EstadoDeCuenta,
    PopupComprobanteElectronico,
    BeneficiosDesbloqueados,
    PopupProyeccion,
    HoyDesktopHasta5,
    MisSolicitudes,
    DocumentosEndoso,
    EstadoDeCuentaDesktop,
    ComprobanteElectronicoDesktop,
    MisBeneficiariosDesktop,
    MiAgenteDesktop,
    CoberturasDesktop,
    ProyeccionDesktop
  },
  data () {
    return {
      noActionSend: false,
      actionSent: false,
      poliza: {},
      usuario: {},
      iconMoneyMontoAsegurado: require('./../../assets/icons-mis-seguros/icon-money.svg'),
      iconDevolucion: require('./../../assets/icons-mis-seguros/icon-devolucion.svg'),
      iconlistFlag: require('./../../assets/icons-mis-seguros/icon-round-navigate-next.svg'),
      iconMisDatos: require('./../../assets/icons-mis-seguros/icon-datos-mi-seguro.svg'),
      iconMisSolicitudes: require('./../../assets/icons-mis-seguros/icon-mis-solicitudes.svg'),
      iconMiEstadoCuenta: require('./../../assets/icons-mis-seguros/icono-mi-estado-cuenta.svg'),
      iconComprobanteElectronico: require('./../../assets/icons-mis-seguros/icon-comprobante-electrónico.svg'),
      iconMisBeneficiarios: require('./../../assets/icons-mis-seguros/icono-mis-beneficiarios.svg'),
      iconMiAgente: require('./../../assets/icons-mis-seguros/icono-mi-agente.svg'),
      iconBeneficios: require('./../../assets/icons/icon-nuevo.svg'),
      iconDescargaComprobante: require('./../../assets/icons-mis-seguros/icon-flag-down.svg'),
      periodoDeCobertura: null,
      totalPagosEfectuados: 0,
      flagPlan: true,
      flagHoy: false,
      flagHoyView1: false,
      flagHoyView2: false,
      flagProyeccion: false,
      openDevolucionPopup: false,
      flagOpenCobertura: false,
      flagOpenMisSolicitudes: false,
      flagOpenMisBeneficiarios: false,
      flagOpenComprobante: false,
      flagMiSeguro: false,
      flagAgente: false,
      flagEstadoCuenta: false,
      flagBeneficiosDesbloqueados: false,
      flagDatosMisSeguros: false,
      flagMisSolicitudes: false,
      flagComprobante: false,
      flagBeneficiarios: false,
      flagMiAgente: false,
      flagCoberturas: false,
      flagDocumentosEndoso: false,
      documentosEndosoDisponibles: [],
      requerimientoId: null,
      mayor5Anhos: false,
      beneficiariosPrincipalesProp: [],
      beneficiariosContingentesProp: [],
      listComrpobantesElectronicosActuales: [],
      listComprobantesElectronicos: [],
      items: [],
      ce: {
        maxDate: null,
        minDate: null,
        modalStart: false,
        modalEnd: false,
        startDate: null,
        endDate: null,
        textFieldStartDate: null,
        textFieldEndDate: null
      },
      solicitudBeneficiarios: [],
      solicitudComodin: [],
      solicitudEndosoEntidadFinanciera: [],
      solicitudLiberacionEndoso: [],
      solicitudAnulacion: [],
      solicitudSeguimiento: [],
      calculoPagoAnual: 0,
      selectedTypeDoc: [],
      loader: {
        flag: false,
        text: 'Cargando la página...'
      },
      taggeo: {
        tipoDocumento: '',
        numeroDocumento: '',
        numeroPoliza: '',
        ramo: '',
        producto: '',
        nombreProducto: '',
        nombre: 'Mis Seguros - VIDA FREE',
        antiguedad: 0
      },
      popupAlert: {
        openPopup: false,
        image: require('@/assets/characters/informa.svg'),
        title: 'Estimado cliente',
        message: '',
        messageButton: 'Entendido',
        buttonClose: false,
        imgHeight: 150,
        imgWidth: 150
      },
      hoy: [
        {
          anho: '02',
          lock: false
        }, {
          anho: '03',
          lock: false
        }, {
          anho: '04',
          lock: false
        }, {
          anho: '05',
          lock: false
        }
      ],
      cuotaPeriodo: 0,
      flagToolTipOnboarding: true
    }
  },
  mounted () {
    let self = this
    if (this.infoPoliza) {
      this.poliza = this.infoPoliza
      this.usuario = this.infoUser

      this.poliza.periodoDePago = parseInt(this.poliza.periodoPago)
      this.poliza.periodoDeCobertura = this.periodoDePagoMethod(this.poliza.fechaVigencia, this.poliza.fechaFinVigencia)
      this.formatMoneyMethod()

      // lowerCase info usuario
      this.usuario.nombre = this.infoUser.nombre.toLowerCase()
      this.usuario.apPaterno = this.infoUser.apPaterno.toLowerCase()
      this.usuario.apMaterno = this.infoUser.apMaterno.toLowerCase()
      let auxNombre = this.usuario.nombre.split(' ')
      this.usuario.titleName = auxNombre[0]

      // lowerCase poliza
      this.poliza.frecuenciaPago = this.poliza.frecuenciaPago.toLowerCase()

      // lowerCase coberturas
      this.poliza.coberturasVida = this.infoPoliza.coberturasVida.map(data => {
        data.nombre = data.nombre.toLowerCase()
        data.nombre = data.nombre.charAt(0).toUpperCase() + data.nombre.slice(1)

        return data
      })

      this.poliza.cliente = this.usuario
      sessionStorage.setItem('infoPoliza', JSON.stringify(this.poliza))
    } else {
      this.poliza = JSON.parse(sessionStorage.getItem('infoPoliza'))
      this.usuario = this.poliza.cliente
    }
    this.consultarDocumentosEndoso(this.poliza.numeroPoliza, this.poliza.flagCesionada || 'NO')
    var startDate = moment(this.poliza.fechaFinVigencia, 'DD-MM-YYYY')
    var endDate = moment(this.poliza.fechaVigencia, 'DD-MM-YYYY')
    this.periodoDeCobertura = endDate.diff(startDate, 'years')

    // MAYOR - MENOR A 5 AÑOS
    let inicioVigencia = self.poliza.fechaVigencia.split(/[/-]/)
    let hoy = new Date()
    let auxInicioVigencia = new Date(Number(inicioVigencia[2]), (Number(inicioVigencia[1]) - 1), Number(inicioVigencia[0]))
    let auxAntiguedad = self.getDiferenciaAnhos(hoy, auxInicioVigencia)
    self.mayor5Anhos = auxAntiguedad >= 5
    // MAYOR A 2 AÑOS
    self.mas2Anhos = auxAntiguedad >= 2

    // SETEANDO OBJ PARA TAGGEO
    self.taggeo.tipoDocumento = self.usuario.tipoDocumento
    self.taggeo.numeroDocumento = self.usuario.numeroDocumento
    self.taggeo.numeroPoliza = self.poliza.numeroPoliza
    self.taggeo.ramo = self.poliza.ramo
    self.taggeo.producto = self.poliza.producto
    self.taggeo.nombreProducto = self.poliza.plan
    self.taggeo.antiguedad = auxAntiguedad

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'desktop'
      }
    })
    // OBTENIENDO BENEFICIARIOS
    self.getBenefits({ numeroPoliza: self.poliza.numeroPoliza })
      .then(res => {
        res.data.forEach(dato => {
          if (dato.tipoBeneficiario === 'CONTINGENTE') {
            self.beneficiariosContingentesProp.push({ ...dato })
          } else {
            self.beneficiariosPrincipalesProp.push({ ...dato })
          }
        })
      })
    // OBTENIENDO COMPROBANTES
    // TMP: Fechas para comprobante electronico
    let auxDate = new Date()
    auxDate.setMonth(auxDate.getMonth() - 12)
    self.ce.startDate = moment(auxDate, 'DD-MM-YYYY').format('YYYY-MM')
    self.ce.endDate = moment(new Date(), 'DD-MM-YYYY').format('YYYY-MM')

    this.getComprobantes({ numeroPoliza: Number(self.poliza.numeroPoliza) })
      .then(res => {
        if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length > 0)) {
          self.listComrpobantesElectronicosActuales = res.data.documentos
          let documents = self.listComrpobantesElectronicosActuales
          let arrDocuments = []
          // SE OBTIENE LOS CODIGOS DE SUNAT DE CADA COMPROBANTE
          for (let index = 0; index < documents.length; index++) {
            arrDocuments.push(documents[index].tipoComprobante)
          }
          let arrDocsUniq = arrDocuments.filter(function (item, pos) {
            return arrDocuments.indexOf(item) === pos
          })
          // - this.items.push({ text: 'Tipo de comprobante', value: null })
          arrDocsUniq.forEach(el => {
            for (let j = 0; j < electronicVouchers.length; j++) {
              let noEncontroMatch = true
              // SE HACE MATCH
              if (electronicVouchers[j].codigoSunat === el) {
                // DETECTAR SI YA ESTA REPETIDO DEL LEGACY
                for (let x = 0; x < self.items.length; x++) {
                  if (self.items[x].text === electronicVouchers[j].descripcion) {
                    let newValue = self.items[x].value.split('.')
                    self.items[x].value = newValue[0] + '.' + electronicVouchers[j].codigoSunat + '.PESC'
                    noEncontroMatch = false
                    break
                  }
                }
                if (noEncontroMatch) {
                  self.items.push({ text: electronicVouchers[j].descripcion, value: electronicVouchers[j].codigoSunat + '.ESC' })
                  break
                }
              }
            }
          })
          if (self.items.length > 1) {
            self.selectedTypeDoc = self.items.map(dt => dt.value)
          }
        }
      })
      .catch(() => {
        /* EL SERVICIO TARDA MUCHO EN DAR LA RESPUESTA DE ERROR
          SE AGREGA UN POPUP VALIDANDO SI SE TIENE O NO UNA LISTA DE COMPROBANTES
        self.popupAlert.openPopup = true
        self.popupAlert.title = "Estimado cliente"
        self.popupAlert.message = "Tenemos problemas con la descarga de sus Comprobantes Electronicos."
        self.popupAlert.messageButton = "Entendido"
        self.popupAlert.buttonClose = false
        */
      })

    // CARGAR SOLICITUDES
    self.getAllRequirementsPerPolicy({ numeroPoliza: self.poliza.numeroPoliza })
      .then(data => {
        data.data.data.forEach(solicitud => {
          if (solicitud.transact.toLowerCase() === 'modificación de beneficiarios') {
            self.solicitudBeneficiarios.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'cuota comodín') {
            self.solicitudComodin.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'endoso a entidad financiera') {
            self.solicitudEndosoEntidadFinanciera.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'liberación de endoso') {
            self.solicitudLiberacionEndoso.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'anulación de poliza') {
            self.solicitudAnulacion.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'seguimiento de solicitudes') {
            self.solicitudSeguimiento.push(solicitud)
          }
        })
      }).catch(() => {
        self.popupAlert.openPopup = true
        self.popupAlert.title = 'Estimado cliente'
        self.popupAlert.message = 'No hemos logrado obtener la información solicitada. Por favor, volver a intentarlo en unos minutos.'
        self.popupAlert.messageButton = 'Entendido'
        self.popupAlert.buttonClose = false
      })

    // this.puedeSolicitudes = (this.poliza.puedeEndosar || this.poliza.puedeCuotaComodin || this.poliza.puedeCambiarFrecuencia || this.poliza.puedeLiberarEndoso || this.poliza.puedeCambiarBeneficiario)
    this.puedeSolicitudes = (this.poliza.puedeCambiarBeneficiario)

    // CALCULO PAGO ANUAL

    switch (this.poliza.frecuenciaPago.toLowerCase()) {
    case paymentFrequency[0].periodo:
      this.calculoPagoAnual = Number(this.poliza.netoPago) * paymentFrequency[0].pagos
      break
    case paymentFrequency[1].periodo:
      this.calculoPagoAnual = Number(this.poliza.netoPago) * paymentFrequency[1].pagos
      break
    case paymentFrequency[2].periodo:
      this.calculoPagoAnual = Number(this.poliza.netoPago) * paymentFrequency[2].pagos
      break
    case paymentFrequency[3].periodo:
      this.calculoPagoAnual = Number(this.poliza.netoPago) * paymentFrequency[3].pagos
      break
    default:
      // console.log('****************FP')
      break
    }

    if (!self.poliza.tablaDevoluciones) {
      self.flagToolTipOnboarding = false
    } else if (self.poliza.tablaDevoluciones.length === 0) {
      self.flagToolTipOnboarding = false
    }

    if (this.action) {
      this.methodView(this.action.action)
      this.actionSent = true
    } else {
      this.methodView('mis seguros')
    }
  },
  methods: {
    ...mapActions('user', ['getBenefits', 'getComprobantes', 'getPDFPolizaElectronica']),
    ...mapActions('requirements', ['getAllRequirementsPerPolicy', 'filterPolicyRequirements']),
    ...mapActions('endorsements', ['getDocsEndorsement']),
    ...mapActions('event', ['eventLog']),
    setFormatNumber (number) {
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number)
    },
    methodView (item) {
      let self = this
      const nombreProducto = this.poliza.nombreProducto || this.poliza.producto
      if (item === 'comprobante' && !Functionalities.isAvailable(Functionalities.vida.COMPROBANTES, self.functionsRules, self, nombreProducto)) {
        return
      }
      if (this.actionSent) {
        this.noActionSend = true
      }
      self.flagProyeccion = item === 'proyección'
      self.flagHoy = item === 'hoy'
      self.flagOpenMisSolicitudes = item === 'solicitudes'
      self.flagOpenCobertura = item === 'coberturas'
      self.flagDatosMisSeguros = (item === 'plan' || item === 'mis seguros')
      self.flagMisSolicitudes = item === 'mis solicitudes'
      self.flagDocumentosEndoso = item === 'documentos de endoso'
      self.flagBeneficiarios = item === 'beneficiarios'
      self.flagOpenComprobante = item === 'comprobante'
      self.flagBeneficiosDesbloqueados = item === 'beneficios'
      self.flagHoyView1 = false
      self.flagHoyView2 = false
      self.flagMiAgente = item === 'mi agente'
      self.flagComprobante = item === 'comprobante'
      self.flagEstadoCuenta = item === 'estado de cuenta'
      self.flagCoberturas = item === 'ver coberturas'
      self.flagPlan = item === 'plan' || item === '' || item === undefined || self.flagAgente || self.flagBeneficiosDesbloqueados || self.flagBeneficiarios || self.flagDatosMisSeguros || self.flagMisSolicitudes || self.flagComprobante || self.flagEstadoCuenta || self.flagMiAgente || self.flagDocumentosEndoso

      // COMPROBANTES
      if (this.flagOpenComprobante) {
        if (this.listComrpobantesElectronicosActuales.length > 0) {
          self.showComprobantesElectronicos()
        } else {
          self.popupAlert.openPopup = true
          self.popupAlert.title = 'Estimado cliente'
          self.popupAlert.message = 'En estos momentos, estamos trabajando en poner a disposición tu comprobante. Pero no te preocupes, en un plazo máximo de 5 días hábiles ya lo tendrás listo para la descarga.' // 'No hemos logrado obtener la información solicitada. Por favor, volver a intentarlo en unos minutos.'
          self.popupAlert.messageButton = 'Entendido'
          self.popupAlert.buttonClose = false
        }
      }
      this.loader.flag = false

      // HOY
      if (this.flagHoy) {
        let inicioVigencia = this.poliza.fechaVigencia.split(/[/-]/)

        let hoy = new Date()
        let auxInicioVigencia = new Date(Number(inicioVigencia[2]), (Number(inicioVigencia[1]) - 1), Number(inicioVigencia[0]))
        let auxlimit = this.getDiferenciaAnhos(hoy, auxInicioVigencia)
        this.flagHoyView1 = auxlimit > 5
        this.flagHoyView2 = auxlimit <= 5
      }

      if (self.flagProyeccion) {
        let today = new Date()
        let pagadoHasta = this.poliza.pagadoHasta.split(/[/-]/)
        let auxPagadoHasta = new Date(Number(pagadoHasta[2]), Number(pagadoHasta[1]) - 1, Number(pagadoHasta[0]))

        if (today > auxPagadoHasta) {
          this.popupAlert.openPopup = true
          this.popupAlert.image = require('@/assets/characters/informa.svg')
          this.popupAlert.title = 'Estimado cliente'
          this.popupAlert.message = 'Aún cuenta con cuotas pendientes de pago'
          this.popupAlert.messageButton = 'Pago de cuotas'
          this.popupAlert.buttonClose = true
        }
      }
    },
    periodoDePagoMethod (inicio, fin) {
      let inicioVigencia = inicio.split(/[/-]/)
      let finVigencia = fin.split(/[/-]/)

      let auxInicio = new Date(inicioVigencia[2], (inicioVigencia[1] - 1), inicioVigencia[0])
      let auxFin = new Date(finVigencia[2], (finVigencia[1] - 1), finVigencia[0])

      let periodoDePago = auxFin.getTime() - auxInicio.getTime()

      let aniosTotales = periodoDePago / (1000 * 3600 * 24 * 365)

      return Math.floor(aniosTotales)
    },
    formatMoneyMethod () {
      let tipoMoneda = (this.poliza.primaProgramadaMoneda === 'NUEVO SOL' ? 'S/' : '$')
      let montoAsegurado = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.poliza.montoCoberturaPrincipal)
      // let montoAsegurado = tipoMoneda.concat(this.poliza.montoCoberturaPrincipal)
      // let pagoEfectuados = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.poliza.totalPagosEfectuados)
      let montoCuota = this.setFormatNumber(this.poliza.netoPago)
      this.poliza.montoAsegurado = montoAsegurado
      this.poliza.montoCuota = montoCuota
      this.poliza.tipoMoneda = tipoMoneda
      this.totalPagosEfectuados = parseFloat(this.poliza.totalPagosEfectuados).toLocaleString('en-US')
    },
    desplegarDatosMiSeguro (flag) {
      this.flagMiSeguro = (!flag)
    },
    showComprobantesElectronicos () {
      let self = this
      const nombreProducto = this.poliza.nombreProducto || this.poliza.producto
      if (!Functionalities.isAvailable(Functionalities.vida.COMPROBANTES, self.functionsRules, self, nombreProducto)) {
        return
      }
      if (this.listComrpobantesElectronicosActuales.length < 1) {
        this.errorModalComprobantes = true
      }
      // EVENT TRACK  Universal Analytics
      /* this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mi seguros - Comprobante electrónico',
        label: 'Seleccionar botón - Aplicar'
      }) */
      // EVENT TRACK  GA4
      /* this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mi seguros - Comprobante electrónico',
        CTA: 'Seleccionar botón - Aplicar'
      }) */

      if (self.ce.startDate !== null && self.ce.endDate !== null) {
        this.loader.flag = true
        // LIMPIANDO LOS COMPROBANTES
        this.listComprobantesElectronicos = []
        let startDate = moment(self.ce.startDate + '-01')
        let endDate = moment(self.ce.endDate).endOf('month')
        // CONDICIONAL PARA CUBRIR TODOS LOS COMPROBANTES
        if (this.listComrpobantesElectronicosActuales.length > 0) {
          let documents = this.listComrpobantesElectronicosActuales
          // POBLANDO LOS COMPROBANTES
          for (let index = 0; index < documents.length; index++) {
            let fechaEmision = moment(documents[index].fechaEmision)
            if (fechaEmision.isBetween(startDate, endDate)) {
              let fechaEmisionFormat = moment(documents[index].fechaEmision, 'YYYY-MM-DD').locale('es').format('MMM-YYYY').replace('.', '')
              fechaEmisionFormat = fechaEmisionFormat.charAt(0).toUpperCase() + fechaEmisionFormat.slice(1)
              let hash = {
                fechaEmision: fechaEmisionFormat,
                tipoDocumento: documents[index].tipoComprobante,
                serie: documents[index].serie,
                correlativo: documents[index].numero,
                historico: false
              }
              this.listComprobantesElectronicos.push(hash)
            }
          }
        }
      } else {
        self.popupAlert.openPopup = true
        self.popupAlert.title = 'Estimado cliente'
        self.popupAlert.messageButton = 'Entendido'
        self.popupAlert.image = require('@/assets/characters/informa.svg')
        self.popupAlert.message = 'No podemos realizar la descarga. Intente nuevamente en unos minutos o contáctese con servicio de atención al cliente.'
        // self.$swal({
        //   title: 'Estimado cliente',
        //   text: 'Debe completar la información para buscar sus comprobantes electrónicos.',
        //   type: 'info',
        //   showCancelButton: false,
        //   confirmButtonColor: '#2177CC',
        //   confirmButtonText: 'Entendido'
        // })
      }
    },
    getDiferenciaAnhos (date1, date2) {
      let diferencia = (date2.getTime() - date1.getTime()) / 1000 / (3600 * 24)
      return Math.abs(Math.round(diferencia / 365.25))
    },
    desplegarAgente (flag) {
      this.flagAgente = (!flag)
    },
    desplegarEstadoDeCuenta (flag) {
      this.flagEstadoCuenta = (!flag)
    },
    async getPDFElectronicPolicy () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.DESCARGA_POLIZA, self.functionsRules, self, self.poliza.producto)) {
        return
      }
      this.loader.flag = true
      this.loader.text = 'Descargando Póliza...'
      await this.getPdfPoliza({numPoliza: this.poliza.numeroPoliza, makeDownload: true}, this.poliza.codigoProceso)
    },
    async getPdfPoliza (data, codigosProceso) {
      const self = this
      const metadata = []
      let downloaded = false
      for (let x = 0; x < codigosProceso.length && !downloaded; x++) {
        try {
          const res = await this.getPDFPolizaElectronica({...data, codProceso: codigosProceso[x]})
          if (res.status === 204) {
            this.loader.flag = false
            metadata[codigosProceso[x]] = {
              statusCode: res.status,
              codProceso: codigosProceso[x]
            }
            metadata.push({status: res.status, codigo: codigosProceso[x]})
            if (x === codigosProceso.length - 1) {
              self.loader.flag = false
              self.popupAlert.openPopup = true
              self.popupAlert.image = require('@/assets/characters/informa.svg')
              self.popupAlert.title = 'Comunicado'
              self.popupAlert.message = 'Lamentamos las molestias, esta póliza aún no está disponible en formato electrónico. Estamos trabajando para ofrecerla lo antes posible.'
              self.popupAlert.messageButton = 'Entendido'
            }
          } else {
            this.loader.flag = false
            downloaded = true
          }
        } catch (error) {
          metadata.push({ error: error.response, codProceso: codigosProceso[x] })
          if (x === codigosProceso.length - 1) {
            this.loader.flag = false
            self.popupAlert.openPopup = true
            self.popupAlert.image = require('@/assets/characters/informa.svg')
            self.popupAlert.title = 'Comunicado'
            self.popupAlert.message = 'No podemos realizar la descarga. Intente nuevamente en unos minutos o contáctese con servicio de atención al cliente.'
            self.popupAlert.messageButton = 'Entendido'
          }
        }
      }

      setTimeout(() => {
        self.$root.$emit('showNps', {
          nombre: 'NPS - Inicio de Encuesta',
          funcionalidad: 'Descarga de póliza',
          metadata: {
            error: metadata.length > 0 ? { response: metadata } : undefined,
            numeroPoliza: self.taggeo.numeroPoliza,
            productoConsultado: self.taggeo.ramo,
            subproductoConsultado: self.taggeo.nombreProducto
          }
        })
      }, 3000)
    },
    closeAlertMethod (item) {
      if (this.flagProyeccion && item) {
        this.$router.push('/pago-de-cuotas')
      } else if (this.flagHoy && item) {
        this.methodView('hoy')
      } else {
        this.methodView('plan')
      }
      this.popupAlert.openPopup = false
      this.loader.flag = false
    },
    consultarDocumentosEndoso (numeroPoliza, flagCesionada) {
      const self = this
      const params = {
        numeroPoliza: numeroPoliza
      }
      self.getAllRequirementsPerPolicy(params).then(res => {
        if (res.data.success && res.data.data.length > 0) {
          self.documentosEndosoDisponibles = res.data.data.flatMap(req =>
            (req.req_files || []).map(file => ({
              ...file,
              state: req.state
            }))
          )
          console.log('==> Docs Endosos', self.documentosEndosoDisponibles)
        } else {
          self.documentosEndosoDisponibles = []
        }
      }).catch(() => {
        self.documentosEndosoDisponibles = []
      })
    }
  },
  computed: {
    ...mapGetters('user', ['functionsRules']),
    flagOcultarMontoDevolucion() {
      return true
    }
  }
}
</script>
<style scoped>
@media screen and (min-width:1024px) {

  .main-vida-free {
    display: flex;
    align-items: center;
  }

  .main-vida-free:last-child {
    margin: auto 0;
  }

  .box-vida-free-body {
    width: fit-content;
    margin-right: 0rem;
    margin-left: auto;
  }

  .box-vida-free-body span,
  p {
    color: var(--text-color) !important;
    letter-spacing: 0;
  }

  .box-vida-free-body .title p:first-child {
    color: #0855C4 !important;
    font-weight: 600 !important;
    font-size: 18px;
    margin-bottom: 5px;
    text-transform: capitalize;
  }

  .box-vida-free-body .title p:last-child {
    font-size: 14px;
    margin: 0px;
  }

  .box-vida-free-body .title p:last-child span {
    font-weight: 600 !important;
  }

  .box-vida-free-body .first-section {
    min-width: 23rem;
    max-width: 27rem;
  }

  .box-vida-free-body .options-buttons {
    margin-bottom: 1rem;
    margin-top: 1em;
    margin-left: 0em;
    margin-right: auto;
    width: 22.5em;
  }

  .box-vida-free-body .box-detail {
    background-color: #F1F1F1;
    padding: 0.5rem 0rem;
    border-radius: 9px;
    width: 22.5em;
  }

  .box-vida-free-body .box-detail-devolucion {
    width: 22.5em;
  }

  .box-vida-free-body .box-detail .detail:nth-child(1) {
    margin-bottom: 5px;
  }

  .box-vida-free-body .box-detail .detail:nth-child(1) span {
    font-weight: 600 !important;
  }

  .box-vida-free-body .box-detail .detail:nth-child(2) {
    margin: 0.3em 0em;
  }

  .box-vida-free-body .second-section {
    width: 24.5rem;
    height: 13rem;
    box-sizing: content-box;
    width: 22.5em;
    padding-right: 1.4em;
    overflow-y: overlay;
  }

  .box-vida-free-body .second-section .menu-vida-free {
    padding: 0.1em 0.5em 0em 1em;
    border: 1px solid #C4C4C4;
    border-radius: 10px;
    margin-bottom: 5px;
    cursor: pointer;
  }

  .box-vida-free-body .second-section .menu-vida-free:last-child {
    margin-bottom: 1px;
  }

  .box-vida-free-body .second-section .menu-vida-free:hover {
    background-color: #f9f9f9;
  }
}

@media (min-width : 1400px), (min-height: 900px) {
  .main-vida-free {
    align-items: flex-start;
  }

  .main-vida-free:last-child {
    margin-top: 5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vida-free/VidaFreeDesktop.vue